import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { CircularProgress } from "@material-ui/core";
import { IDTRequests, IDTResponses } from "../../Constantes/idtMessageTypes";
import { baseRequest } from "../../fetch/basicThunk";
import { QUERY_CLOSE_IDT_PROCESS, QUERY_GET_IDT_ENTITY_PARAMETERS, QUERY_GET_IDT_PROCESS_BY_ID, QUERY_GET_IDT_PROCESS_TYPES, QUERY_GET_INTERACTION_CODE, QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID, QUERY_OPEN_LINKED_PROCESS, QUERY_POST_NEW_IDT_PROCESS_FROM_INTERACTION_CODE, QUERY_RETURN_PARENT_PROCESS, QUERY_SEND_IDT_API_REQUEST, QUERY_UPDATE_IDT_PLACEHOLDER_VALUE, QUERY_UPDATE_IDT_PLACEHOLDER_VALUE_LIST, QUERY_UPDATE_IDT_PROCESS  } from "../../fetch/constantQueries";
import { selectContractCase } from "../../redux/contract/selectors";
import { updateIdtProcessId } from "../../redux/contract/contractSlice";

function Processes(props){

    const {treeDisplay, treeIframeId} = props;
    const idtUrl = window.getConfig("IDT_URL");
    const idtSrc = idtUrl + window.getConfig("IDT_PATHNAME");
    const currentCase = useSelector(selectContractCase);
    const [noProcessAvaliable, setNoProcessAvaliable] = useState(false)
    const [loadedFrame, setLoadedFrame] = useState(false);
    const [loadedIdt, setLoadedIdt] = useState(false)
    const dispatch = useDispatch();

    useEffect(()=>{
        window.addEventListener("message",listenToIdtMessages,false);
        return ()=> window.removeEventListener("message", listenToIdtMessages)
    },[])

    useEffect(()=>{
        if(currentCase && loadedIdt){ 
            setNoProcessAvaliable(false);
            fetchInteractionCode()
        }  
    },[currentCase?.caseId, currentCase?.taxonomyId, loadedIdt])


    async function fetchInteractionCode(){
        const taxonomy = {
            taxonomyLevel_1 : currentCase.taxonomyLevel_1?.key,
            taxonomyLevel_2 : currentCase.taxonomyLevel_2?.key,
            taxonomyLevel_3 : currentCase.taxonomyLevel_3?.key,
            taxonomyLevel_4 : currentCase.taxonomyLevel_4?.key
            }

        try {
          const interaction = await baseRequest({body: {taxonomy, caseId: currentCase.caseId, caseStateId: currentCase.stateId}}, dispatch, QUERY_GET_INTERACTION_CODE, "POST");

          let idtProcess;

          sendLoadingTreeInfo();

          baseRequest(null, dispatch, QUERY_GET_IDT_ENTITY_PARAMETERS, "GET").then(
            data=> {sendEntityParametersInfo(data)}
          )

            if(currentCase.closeDate && currentCase?.idtProcessId){
                idtProcess = await baseRequest({param: `${currentCase?.idtProcessId}`, query:`?lastInChain=${true}`}, dispatch, QUERY_GET_IDT_PROCESS_BY_ID, "GET")
            } else {
                const newIdtProcessInput = {
                    interactionCode : interaction.interactionCode,
                    crmCaseId: currentCase?.caseId,
                    idtCaseId: currentCase?.idtProcessId,
                    closeCase: false
                }
                idtProcess = await baseRequest({body: newIdtProcessInput}, dispatch, QUERY_POST_NEW_IDT_PROCESS_FROM_INTERACTION_CODE, "POST")
                dispatch(updateIdtProcessId(idtProcess.processId))
            }
          
          sendTreeInfo(idtProcess);

          baseRequest({param: `${idtProcess.processId}`}, dispatch, QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID, "GET").then(
            data=> {sendPlaceholdersInfo(data)}
          )

          baseRequest({}, dispatch, QUERY_GET_IDT_PROCESS_TYPES, "GET").then(
            data=> {sendProcessTypesInfo(data)}
          )

        } catch (error) {
            sendErrorInfo(error.message)
        }     
    }

    function listenToIdtMessages(event){
        if (event.origin !== idtUrl) return; //si los mensajes vienen de otra pestaña que no sea el iframe del idt, ignorarlos
        if( event.data.type === IDTResponses.LOADING && event.data.load){ //esperamos a que el iframe confirme que ha montado el componente y el listener antes de enviar el mensaje, de lo contrario no lo recibirá
           setLoadedIdt(event.data.load)
           sendDisplayInfo(treeDisplay);
        }
        if(event.data.type === IDTResponses.UPDATE_PROCESS){
            baseRequest({param: event.data.clickTraceData.processId, body: event.data.clickTraceData, query: `?isActive=${event.data.clickTraceData.isActive}`}, dispatch, QUERY_UPDATE_IDT_PROCESS , "POST")
        }
        if(event.data.type === IDTResponses.CLOSE_PROCESS){
           baseRequest({param: `${event.data.closeProcessData.processId}`, body: {...event.data.closeProcessData, crmCaseId: currentCase?.caseId}}, dispatch, QUERY_CLOSE_IDT_PROCESS, "POST").then(
            relatedProcessId=> {
                if(relatedProcessId > 0){
                    dispatch(updateIdtProcessId(relatedProcessId))
                    baseRequest({param: `${relatedProcessId}`, query:`?lastInChain=${true}`}, dispatch, QUERY_GET_IDT_PROCESS_BY_ID, "GET").then(
                        idtProcessData=>{
                            sendTreeInfo(idtProcessData);
                            baseRequest({param: `${idtProcessData.processId}`}, dispatch, QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID, "GET").then(
                                data=> {sendPlaceholdersInfo(data)}
                              )
                        }
                    );    
                } else {
                    baseRequest({param: `${event.data.closeProcessData.processId}`, query:`?lastInChain=${true}`}, dispatch, QUERY_GET_IDT_PROCESS_BY_ID, "GET").then(
                        idtProcessData=>{sendTreeInfo(idtProcessData);}
                    )
                }
            }
           )
        }

        if(event.data.type === IDTResponses.UPDATE_PLACEHOLDER_VALUE){
            baseRequest({body: event.data.placeholderValueData}, dispatch, QUERY_UPDATE_IDT_PLACEHOLDER_VALUE, "POST")
        }
        if(event.data.type === IDTResponses.UPDATE_PLACEHOLDER_VALUE_LIST){
            baseRequest({body: event.data.placeholderValueListData}, dispatch, QUERY_UPDATE_IDT_PLACEHOLDER_VALUE_LIST, "POST").then(
                response=> baseRequest({param: `${event.data.processId}`}, dispatch, QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID, "GET").then(
                    data=> {sendPlaceholdersInfo(data)}
                  )
            )

        }
        if(event.data.type === IDTResponses.RETURN_TO_PARENT_PROCESS){
            baseRequest({query:`?processId=${event.data.processId}&deleteCurrent=${event.data.deleteCurrent}`}, dispatch, QUERY_RETURN_PARENT_PROCESS , "PUT").then(
                idtProcessData=>{
                    sendTreeInfo(idtProcessData);
                    baseRequest({param: `${idtProcessData.processId}`}, dispatch, QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID, "GET").then(
                        data=> {sendPlaceholdersInfo(data)}
                      )}
            )
        }
        if(event.data.type === IDTResponses.OPEN_PROCESS)
        {
            baseRequest({query:`?processId=${event.data.processId}&linkedProcessTypeId=${event.data.linkedProcessTypeId}`}, dispatch, QUERY_OPEN_LINKED_PROCESS, "PUT").then(
                idtProcessData=>{
                    sendTreeInfo(idtProcessData);
                    baseRequest({param: `${idtProcessData.processId}`}, dispatch, QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID, "GET").then(
                        data=> {sendPlaceholdersInfo(data)}
                      )}
            )
        }
        if(event.data.type === IDTResponses.NAVIGATE_TO){
            baseRequest({param: `${event.data.processId}`, query:`?lastInChain=${false}`}, dispatch, QUERY_GET_IDT_PROCESS_BY_ID, "GET").then(
                idtProcessData=>{
                    sendTreeInfo(idtProcessData);
                    baseRequest({param: `${idtProcessData.processId}`}, dispatch, QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID, "GET").then(
                        data=> {sendPlaceholdersInfo(data)}
                      )
                }
            ); 
        } 
        if(event.data.type === IDTResponses.SEND_API_REQUEST){

                baseRequest({body: event.data.requestData}, dispatch, QUERY_SEND_IDT_API_REQUEST , "POST").then(
                    idtResponseData=>{
                        if(idtResponseData.showValueNode === true){
                            baseRequest({param: `${event.data.requestData.processId}`}, dispatch, QUERY_GET_PLACEHOLDER_VALUES_BY_PROCESS_ID, "GET").then(
                                data=> {sendPlaceholdersInfo(data)}
                              )   
                        }
                        sendApiResponseInfo(idtResponseData, false)
                    }
                ).catch(
                    error=>{
                        sendApiResponseInfo(null, true)
                    }
                )
        }
    }

    function sendTreeInfo(tree){     
        const messageType = IDTRequests.LOAD_TREE_END
        const message = {
            type: messageType,
            processData: tree,
            crmCaseId: currentCase.caseId,
        }
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
        return false;
    }

    function sendApiResponseInfo(response, error){
        const messageType = IDTRequests.LOAD_API_RESPONSE;
        const message = {
            type: messageType,
            responseData : {...response, error},
            crmCaseId : currentCase.caseId
        }
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
        return false;
    }

    function sendLoadingTreeInfo(){       
        const messageType = IDTRequests.LOAD_TREE_START
        const message = {
            type: messageType,
        }
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
        return false;
    }

    function sendPlaceholdersInfo(placeholderValues){     
        const messageType = IDTRequests.LOAD_PLACEHOLDER_VALUES;
        const message = {
            type: messageType,
            placeholderData: placeholderValues,
            crmCaseId: currentCase.caseId,
        }
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
        return false;
    }

    function sendEntityParametersInfo(entityParameters){     
        const messageType = IDTRequests.LOAD_ENTITY_PARAMETERS;
        const message = {
            type: messageType,
            entityParameters: entityParameters,
            crmCaseId: currentCase.caseId,
        }
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
        return false;
    }

    function sendProcessTypesInfo(processTypes){       
        const messageType = IDTRequests.LOAD_PROCESS_TYPES
        const message = {
            type: messageType,
            processTypeData: processTypes,
            crmCaseId: currentCase.caseId,
        }
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
        return false;
    }

    function sendProcessTypesInfo(processTypes){       
        const messageType = IDTRequests.LOAD_PROCESS_TYPES
        const message = {
            type: messageType,
            processTypeData: processTypes,
            crmCaseId: currentCase.caseId,
        }
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
        return false;
    }

    function sendDisplayInfo(displayMode){
        const message ={
            type: IDTRequests.DISPLAY_MODE,
            displayMode
        };
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
    }

    function sendErrorInfo(errorMessage){
        const message ={
            type: IDTRequests.ERROR,
            message: errorMessage
        };
        const treeIframe = document.getElementById(treeIframeId);
        treeIframe.contentWindow.postMessage(message, idtUrl);
    }

    function onLoadFrame(){
       setLoadedFrame(true)
    }

    return(
        <>
        <div id="processes" style={{height: 555, paddingTop: !currentCase || noProcessAvaliable ? "1.5rem" : 0 }}>
            {currentCase ?
                noProcessAvaliable 
                ? <div className="process-title-container"> <div className="process-list-item-default">El caso seleccionado no tiene un proceso asociado</div></div>
                : 
                    <>
                        <iframe allow="clipboard-read; clipboard-write" style={{display: loadedFrame? "block" : "none"}} id={treeIframeId} className="tree-iframe" src={idtSrc} onLoad={onLoadFrame}/>
                        <div style={{display: loadedFrame ? "none" : "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
                            <div style={{display: "flex", flexDirection: "column", alignItems: "center", rowGap: 8}}>
                                <CircularProgress/> 
                                <div style={{fontSize: 14}}>Conectando</div>
                            </div>
                        </div>
                    </>
                : <div className="process-title-container"> <div className="process-list-item-default">Seleccione un caso para ver su proceso asociado</div></div>
            }
        </div>
        </>
    )
}

export {Processes}